import crudActions from '../../crud/actions'

const actions = crudActions('CAREASSESSMENT_SOCIAL_INCLUSION_ACTIVITIES_')

export default actions
